package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class SkillQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    name: String,
    color: String,
    icon: String,
    intention: String?,
    target_hours: Long,
    deadline: String?,
    tags: String?,
    pinned: Long,
    archived: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-323_106_030, arrayOf("skill"), driver, "Skill.sq", "selectAll",
      "SELECT skill.id, skill.name, skill.color, skill.icon, skill.intention, skill.target_hours, skill.deadline, skill.tags, skill.pinned, skill.archived, skill.order_index, skill.created_at, skill.updated_at, skill.is_deleted, skill.deleted_at, skill.synced_at FROM skill WHERE is_deleted = 0 ORDER BY order_index, name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectAll(): Query<Skill> = selectAll { id, name, color, icon, intention, target_hours,
      deadline, tags, pinned, archived, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Skill(
      id,
      name,
      color,
      icon,
      intention,
      target_hours,
      deadline,
      tags,
      pinned,
      archived,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    name: String,
    color: String,
    icon: String,
    intention: String?,
    target_hours: Long,
    deadline: String?,
    tags: String?,
    pinned: Long,
    archived: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectById(id: String): Query<Skill> = selectById(id) { id_, name, color, icon,
      intention, target_hours, deadline, tags, pinned, archived, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Skill(
      id_,
      name,
      color,
      icon,
      intention,
      target_hours,
      deadline,
      tags,
      pinned,
      archived,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    name: String,
    color: String,
    icon: String,
    intention: String?,
    target_hours: Long,
    deadline: String?,
    tags: String?,
    pinned: Long,
    archived: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_264_558_845, arrayOf("skill"), driver, "Skill.sq", "selectDirty",
      "SELECT skill.id, skill.name, skill.color, skill.icon, skill.intention, skill.target_hours, skill.deadline, skill.tags, skill.pinned, skill.archived, skill.order_index, skill.created_at, skill.updated_at, skill.is_deleted, skill.deleted_at, skill.synced_at FROM skill WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectDirty(): Query<Skill> = selectDirty { id, name, color, icon, intention,
      target_hours, deadline, tags, pinned, archived, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Skill(
      id,
      name,
      color,
      icon,
      intention,
      target_hours,
      deadline,
      tags,
      pinned,
      archived,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    name: String,
    color: String,
    icon: String,
    intention: String?,
    target_hours: Long,
    deadline: String?,
    tags: String?,
    pinned: Long,
    archived: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Skill> = selectByIdAnyState(id) { id_, name,
      color, icon, intention, target_hours, deadline, tags, pinned, archived, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Skill(
      id_,
      name,
      color,
      icon,
      intention,
      target_hours,
      deadline,
      tags,
      pinned,
      archived,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    name: String,
    color: String,
    icon: String,
    intention: String?,
    target_hours: Long,
    deadline: String?,
    tags: String?,
    pinned: Long,
    archived: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-683_764_276, """
        |INSERT INTO skill(id, name, color, icon, intention, target_hours, deadline, tags, pinned, archived, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 13) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, color)
          bindString(3, icon)
          bindString(4, intention)
          bindLong(5, target_hours)
          bindString(6, deadline)
          bindString(7, tags)
          bindLong(8, pinned)
          bindLong(9, archived)
          bindLong(10, order_index)
          bindLong(11, created_at)
          bindLong(12, updated_at)
        }
    notifyQueries(-683_764_276) { emit ->
      emit("skill")
    }
  }

  public fun update(
    name: String,
    color: String,
    icon: String,
    intention: String?,
    target_hours: Long,
    deadline: String?,
    tags: String?,
    pinned: Long,
    archived: Long,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-338_818_084, """
        |UPDATE skill SET name = ?, color = ?, icon = ?, intention = ?, target_hours = ?, deadline = ?, tags = ?, pinned = ?, archived = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 12) {
          bindString(0, name)
          bindString(1, color)
          bindString(2, icon)
          bindString(3, intention)
          bindLong(4, target_hours)
          bindString(5, deadline)
          bindString(6, tags)
          bindLong(7, pinned)
          bindLong(8, archived)
          bindLong(9, order_index)
          bindLong(10, updated_at)
          bindString(11, id)
        }
    notifyQueries(-338_818_084) { emit ->
      emit("skill")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-365_416_440,
        """UPDATE skill SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-365_416_440) { emit ->
      emit("skill")
    }
  }

  public fun setPinned(
    pinned: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_886_149_351, """UPDATE skill SET pinned = ?, updated_at = ? WHERE id = ?""", 3)
        {
          bindLong(0, pinned)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_886_149_351) { emit ->
      emit("skill")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(837_477_178,
        """UPDATE skill SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(837_477_178) { emit ->
      emit("skill")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-581_475_877,
        """UPDATE skill SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""", 2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-581_475_877) { emit ->
      emit("skill")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("skill", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("skill", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_426_311_039,
        """SELECT skill.id, skill.name, skill.color, skill.icon, skill.intention, skill.target_hours, skill.deadline, skill.tags, skill.pinned, skill.archived, skill.order_index, skill.created_at, skill.updated_at, skill.is_deleted, skill.deleted_at, skill.synced_at FROM skill WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Skill.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("skill", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("skill", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_944_307_290,
        """SELECT skill.id, skill.name, skill.color, skill.icon, skill.intention, skill.target_hours, skill.deadline, skill.tags, skill.pinned, skill.archived, skill.order_index, skill.created_at, skill.updated_at, skill.is_deleted, skill.deleted_at, skill.synced_at FROM skill WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Skill.sq:selectByIdAnyState"
  }
}
